import React, { useState, useEffect } from 'react'
import { Paper, Button } from '@mui/material';
import Loader from '../panel/loader';
import FormDialog from '../panel/modal';
import AddEventForm from '../form/addEventForm';
import ViewEvents from '../table/viewEvents';


const AddEvent = () => {

    const [load, setLoad] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [modalData , setModalData] = React.useState()

    const handleClickOpen = (data) => {
        setOpen(true);
        setModalData(data)
        // console.log(data ,'data22');
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <>
            <div className="row">
                <Paper>
                    <div className="col-12 d-flex justify-content-between p-2">
                        <div></div>
                        <Button variant='contained' onClick={handleClickOpen}>+ Add Event</Button>
                    </div>
                    <FormDialog form={<AddEventForm handleClose={handleClose} modalData={modalData} />} title='Add Event' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                </Paper>
                {load && <Loader />}

                <Paper>
                    <div className="col-12">
                        <ViewEvents handleClickOpen={handleClickOpen} handleClose={handleClose}  />
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default AddEvent;